'use client';

import BookDemoSection from '@/components/BookDemoSection';
import ResourceListHero from '@/components/resourceDetail/ResourceListHero';
import { formatMonthYear } from '@/lib/formatDate';
import { useTranslation } from "@/hooks/useTranslation";
const ITEMS = [{
  id: 1,
  episode: 'Episode 1',
  slug: 'vocx-ep1-genai-human-first-cx',
  title: "VoCX Ep 1: How GenAI Enables Human First CX at Scale",
  featured_image: '/podcasts/ep1.webp',
  date: '2024-01-15'
}, {
  id: 2,
  episode: 'Episode 2',
  slug: 'vocx-ep2-telecom-experience-as-a-service',
  title: "VoCX Ep 2: Telecom's Shift to Experience as a Service - Powered by Real Time AI",
  featured_image: '/podcasts/ep2.webp',
  date: '2024-02-15'
}, {
  id: 3,
  episode: 'Episode 3',
  slug: 'vocx-ep3-beyond-dashboards-prompt-led-intelligence',
  title: 'VoCX Ep 3: Moving Beyond Dashboards to the Prompt Led Future of Customer Intelligence',
  featured_image: '/podcasts/ep3.webp',
  date: '2024-03-15'
}, {
  id: 4,
  episode: 'Episode 4 · Part 1',
  slug: 'vocx-ep4-part1-automation-growth-strategy',
  title: 'VoCX Ep 4 Part 1: Automation as a Growth Strategy - Driving Conversions, Retention, and Brand Trust',
  featured_image: '/podcasts/ep4.webp',
  date: '2024-04-15'
}, {
  id: 5,
  episode: 'Episode 4 · Part 2',
  slug: 'vocx-ep4-part2-automation-growth-strategy',
  title: 'VoCX Ep 4 Part 2: Automation as a Growth Strategy - Driving Conversions, Retention, and Brand Trust',
  featured_image: '/podcasts/ep4.webp',
  date: '2024-04-22'
}, {
  id: 6,
  episode: 'Episode 5',
  slug: 'vocx-ep5-cx-ai-at-the-core',
  title: 'VoCX Episode 5: Customer Experience with AI at the Core: Shift from Customer Insights to Instincts',
  featured_image: '/podcasts/ep5.webp',
  date: '2024-05-15'
}, {
  id: 7,
  episode: 'Episode 6',
  slug: 'vocx-ep6-scaling-cx-autonomy-ai-first',
  title: 'VoCX Episode 6: Scaling Customer Experience Autonomy with AI First Strategies',
  featured_image: '/podcasts/ep6.webp',
  date: '2024-06-15'
}, {
  id: 8,
  episode: 'Episode 7',
  slug: 'vocx-ep7-zero-downtime-engineering-backbone',
  title: "VoCX Ep 7: Zero Downtime, Zero Disruptions: The Engineering Backbone Behind Locobuzz's 24/7 Tech",
  featured_image: '/podcasts/ep7.webp',
  date: '2024-07-15'
}, {
  id: 9,
  episode: 'Episode 8',
  slug: 'vocx-ep8-future-of-marketing-ai-core',
  title: 'VoCX EP 8: Future of Marketing - AI at the Core of Strategic Growth and Brand Integrity',
  featured_image: '/podcasts/ep8.webp',
  date: '2024-08-15'
}];
export default function PodcastsPage() {
  const {
    t
  } = useTranslation();
  return <>
      {/* Hero */}
      <ResourceListHero
        eyebrow={t("res.podcasts")}
        title={t("resources_podcasts.vocx_voice_of_cx_leaders")}
        subtitle={t("resources_podcasts.candid_conversations_with_the_peopl")}
      />

      {/* Grid */}
      <section style={{
      background: '#F8FAFF',
      padding: '56px 0'
    }}>
        <div className="container">
          <div className="lb-grid-3 podcasts-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3,1fr)',
          gap: 24
        }}>
            {ITEMS.map(item => <a key={item.id} href={`/resources/podcasts/${item.slug}`} style={{
            textDecoration: 'none',
            display: 'flex',
            flexDirection: 'column',
            background: '#fff',
            borderRadius: 16,
            overflow: 'hidden',
            border: '1px solid rgba(79,110,247,0.08)',
            boxShadow: '0 2px 12px rgba(79,110,247,0.04)',
            transition: 'all 0.25s'
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 16px 40px rgba(79,110,247,0.1)';
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'none';
            e.currentTarget.style.boxShadow = '0 2px 12px rgba(79,110,247,0.04)';
          }}>

                {/* Thumbnail */}
                <div style={{
              position: 'relative',
              aspectRatio: '16/9',
              overflow: 'hidden',
              background: '#0D1117'
            }}>
                  <img src={item.featured_image} alt={item.title} loading="lazy" decoding="async" style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
                transition: 'transform 0.4s'
              }} onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.04)';
              }} onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
              }}>
                  </img>
                  {/* Play button overlay */}
                  <div style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(0,0,0,0.2)',
                transition: 'background 0.2s'
              }} onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(0,0,0,0.4)';
              }} onMouseLeave={e => {
                e.currentTarget.style.background = 'rgba(0,0,0,0.2)';
              }}>
                    <div style={{
                  width: 52,
                  height: 52,
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.95)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
                }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="#DC2626"><polygon points="5,3 19,12 5,21" /></svg>
                    </div>
                  </div>
                  {/* Episode badge */}
                  <div style={{
                position: 'absolute',
                top: 12,
                left: 12,
                background: 'rgba(220,38,38,0.9)',
                backdropFilter: 'blur(8px)',
                color: '#fff',
                fontSize: 10,
                fontWeight: 800,
                padding: '3px 10px',
                borderRadius: 100,
                fontFamily: "'Inter Tight',sans-serif",
                letterSpacing: '0.3px'
              }}>
                    {item.episode}
                  </div>
                  {/* YouTube badge */}
                  <div style={{
                position: 'absolute',
                top: 12,
                right: 12,
                background: 'rgba(0,0,0,0.7)',
                backdropFilter: 'blur(8px)',
                color: '#fff',
                fontSize: 9,
                fontWeight: 700,
                padding: '3px 8px',
                borderRadius: 6,
                fontFamily: "'Inter Tight',sans-serif",
                display: 'flex',
                alignItems: 'center',
                gap: 4
              }}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="#FF0000"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.54C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58z" /><polygon points="9.75,15.02 15.5,12 9.75,8.98 9.75,15.02" fill="white" /></svg>
                    {t("resources_podcasts.youtube")}
                  </div>
                </div>

                {/* Content */}
                <div style={{
              padding: '20px',
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              gap: 10
            }}>
                  <h3 style={{
                fontFamily: "'Inter Tight',sans-serif",
                fontWeight: 600,
                fontSize: 14,
                color: '#0D1117',
                lineHeight: 1.45,
                margin: 0
              }}>
                    {item.title}
                  </h3>
                  <div style={{
                marginTop: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                    <span style={{
                  fontSize: 11,
                  color: '#9CA3AF',
                  fontFamily: "'Inter Tight',sans-serif"
                }}>
                      {formatMonthYear(item.date)}
                    </span>
                    <span style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#DC2626',
                  fontFamily: "'Inter Tight',sans-serif",
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4
                }}>
                      {t("resources_podcasts.watch_now")}
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                    </span>
                  </div>
                </div>
              </a>)}
          </div>
        </div>
      </section>

      <BookDemoSection />

      <style dangerouslySetInnerHTML={{ __html: `
        @media (max-width: 720px) {
          .podcasts-grid { grid-template-columns: 1fr !important; gap: 18px !important; }
          .podcasts-grid > a > div:first-child { aspect-ratio: 16 / 10 !important; min-height: 240px !important; }
        }
      ` }} />
    </>;
}